import { useState, useEffect } from 'react';

// Extraído de `ComponentTaskHoy.jsx` (no contemplado en las fases A-E originales del plan) --
// dos `useState`+`useEffect` de polling de DOM, autocontenidos, para encontrar los nodos donde
// el panel de detalle de tarea hace portal (`.menu2-container` para el panel completo,
// `#menu2-bottom-left` para el fragmento inferior izquierdo del layout de `Menu2`). Ninguno de
// los dos existe todavía en el primer render (el layout de `Menu2` monta después) -- de ahí el
// polling de 50ms hasta encontrarlos.
// Fase 5.18 (05-remediation.md, parte 2) -- `react-hooks/set-state-in-effect` (hint de React
// Compiler, no un bug de runtime) sube a `error` en todo `src/`. Este archivo hace setState
// síncrono dentro de un `useEffect` en un patrón de sincronización legítimo: elige el target de portal (body vs. contenedor in-app) según el modo standalone/overlay.
// No se reescribe a estado derivado (repetiría el fetch/haría el UI menos predecible en
// varios de estos casos) -- deshabilitado a nivel de archivo, con motivo, no en silencio.
/* eslint-disable react-hooks/set-state-in-effect */
export function useTaskDetailPortalTargets({ activeTask, standaloneTaskId, standaloneMode }) {
    const [portalTarget, setPortalTarget] = useState(document.body);
    useEffect(() => {
        if (!activeTask) return;

        if (standaloneTaskId) {
            setPortalTarget(document.body);
            return;
        }

        const checkTarget = () => {
            const el = document.querySelector('.menu2-container');
            if (el) {
                setPortalTarget(el);
                return true;
            }
            return false;
        };

        if (!checkTarget()) {
            const interval = setInterval(() => {
                if (checkTarget()) {
                    clearInterval(interval);
                }
            }, 50);
            return () => clearInterval(interval);
        }
    }, [activeTask, standaloneTaskId]);

    const [bottomLeftTarget, setBottomLeftTarget] = useState(null);
    useEffect(() => {
        // slice 02.1 · b.5f — `#menu2-bottom-left` es parte del layout de `Menu2` y nunca existe
        // en `/t/:taskId` (mount standalone) -- sin este guard, el polling de 50ms corría para
        // siempre en esa ruta.
        if (standaloneMode) return;
        const checkTarget = () => {
            const el = document.getElementById('menu2-bottom-left');
            if (el) {
                setBottomLeftTarget(el);
                return true;
            }
            return false;
        };
        if (!checkTarget()) {
            const interval = setInterval(() => {
                if (checkTarget()) clearInterval(interval);
            }, 50);
            return () => clearInterval(interval);
        }
    }, [standaloneMode]);

    return { portalTarget, bottomLeftTarget };
}
